import { initializePaddle } from '@paddle/paddle-js';
import store from '../../../store';
import { User } from '../../utils/interfaces/AuthInterface';
import { setIsLoadingCurrentPlan, setIsSuccessUpgradePlan } from '../../../modules/settings/slice/settingsSlice';
import { message } from 'antd';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../utils/analytics';
export const openCheckout = async (priceId: string) => {
  const currentUser = store.getState().auth.user as User | null

  try {
    const paddleInstance = await initializePaddle({token: 'live_3f2466a8b934026a65c52d71c0f',
      eventCallback: function (data) {
        if (data?.name === "checkout.completed") {
          const planName = data.data?.items[0].product.name
          const planPrice = data.data?.totals.subtotal
          const planCurrency = data.data?.currency_code
          paddleInstance?.Checkout.close()
          store.dispatch(setIsLoadingCurrentPlan(true))
          setTimeout(() => {
            store.dispatch(setIsSuccessUpgradePlan(true))
            message.success(`${planName} plan activated successfully`, 5)
          }, 3000)
          logEvent(analytics, `Plan_currency = ${planCurrency}`);
          logEvent(analytics, `Plan_name = ${planName}`);
          logEvent(analytics, `Plan_price = ${planPrice}`);
        } else if (data?.name === "checkout.payment.failed") {
          console.log(data);

        }
      } 
    });
    if (paddleInstance) {
      paddleInstance.Checkout.open({
        items: [{ priceId, quantity: 1 }],
        customer: {
          email: currentUser?.email ?? ''
        },
        customData: {
          userID: currentUser?.id ?? '',
          email: currentUser?.email ?? '',
          companyID: currentUser?.company.id ?? '',
        },
      });
    }
  } catch (error) {
    console.error('Error initializing Paddle:', error);
  }
};
